import { Injectable } from '@angular/core';
import { ConstantValues } from '../models/bpg-constants';
import { Observable, of , BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { environmentLocal } from 'src/environments/environment.local';
import { environmentQA } from 'src/environments/environment.qa'
import { environmentPROD } from 'src/environments/environment.prod'
import 'rxjs/Rx';
import jwt_decode from 'jwt-decode';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Injectable({
  providedIn: 'root'
})
export class BpgCommonService {

  membershipUrl: string = ConstantValues.userManagementApiUrl.userManagementUrl;
  commonUrl: string = ConstantValues.userManagementApiUrl.userManagementUrl;
  financeUrl: string = ConstantValues.financeManagementApiUrl.financeManagementUrl;
  getAWSUrl: string = ConstantValues.userManagementApiUrl.getAWSurl;
  registerSiteUrl: string = ConstantValues.userManagementApiUrl.registerVirtualSiteUrl;
  logUserActionApi: string = ConstantValues.userManagementApiUrl.saveUserActionLogs;
  codeResponse: any = '';
  idToken: any;
  accessToken: any;
  refreshToken1: any;
  tokenURL: any = environment.tokenUrl
  contentTypeConstant = 'application/x-www-form-urlencoded; charset=UTF-8';
  public isSiteOrBpgCreated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public headerRefresh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public loginError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private readonly setloggedInSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  setloggedInObservable = () => this.setloggedInSubject$.asObservable();
  private readonly  isTokenReceived = new BehaviorSubject(sessionStorage.getItem('id_token')===null||sessionStorage.getItem('XAapiKey')===null?null:true); 
  isTokenPresent = this.isTokenReceived.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly environment1: EnvironmentConfiguration,
    // private logger: BPGLoggerService,
    private readonly spinner: Ng4LoadingSpinnerService
    
  ) { }

  getSessionToken() {

      let getAWSCredURL;
      if (this.environment1.envName === 'default' || this.environment1.envName === 'local' || this.environment1.envName === 'staging') {
        getAWSCredURL = environmentLocal.getAWSCredURL
      } else if (this.environment1.envName === 'qa') {
        getAWSCredURL = environmentQA.getAWSCredURL
      }
      else if (this.environment1.envName === 'prod') {
        getAWSCredURL = environmentPROD.getAWSCredURL
      }
      const options = {
        headers: new HttpHeaders({
          'Authorization': sessionStorage.getItem('id_token'),
          'Content-Type': this.contentTypeConstant
        }),

      };
       this.http.get(getAWSCredURL, options).subscribe(async (res2: any) => {

        if (res2 !== null && res2 !== undefined) {
          sessionStorage.setItem('AccessKeyId', (res2['access-key']));
          sessionStorage.setItem('SecretKeyId', (res2['secret-key']));
          sessionStorage.setItem('SessionToken', (res2['session-token']));

        }
      })

  }
  async userLogin() {
    this.spinner.show();
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': this.contentTypeConstant,
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',

        }),
        'responseType': 'text'

      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': this.contentTypeConstant,
        })
      };
    }
    this.codeResponse = sessionStorage.getItem('codeResponse');
    let redirectUri;
    let clientId;
    let getXApiKeyUrl;
    let tokenURL = environment.tokenUrl;
    if (this.environment1.envName === 'default' || this.environment1.envName === 'local' || this.environment1.envName === 'staging') {
      redirectUri = environmentLocal.redirectUri
      clientId = environmentLocal.clientId
      getXApiKeyUrl = environmentLocal.getXApiKeyUrl

    } else if (this.environment1.envName === 'qa') {
      redirectUri = environmentQA.redirectUri
      clientId = environmentQA.clientId
      getXApiKeyUrl = environmentQA.getXApiKeyUrl

    }
    else if (this.environment1.envName === 'prod') {
      redirectUri = environmentPROD.redirectUri
      clientId = environmentPROD.clientId
      getXApiKeyUrl = environmentPROD.getXApiKeyUrl
      tokenURL = environmentPROD.tokenUrl
    }
    const details = {
      'grant_type': 'authorization_code',
      'client_id': clientId,
      'code': this.codeResponse,
      'redirect_uri': redirectUri,
      'code_verifier': environment.codeVerifier
    };
    const formBody = [];
    for (const property in details) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(details[property]);
      formBody.push(`${encodedKey}=${encodedValue}`);
    }
    const body = formBody.join("&");
    return this.http.post(tokenURL, body, httpOptions).subscribe(async (res: any) => {
      if (res !== null) {
        this.idToken = res.id_token;
        this.accessToken = res.access_token;
        this.refreshToken1 = res.refresh_token;
        sessionStorage.setItem('id_token', this.idToken);
        sessionStorage.setItem('access_token', this.accessToken);
        sessionStorage.setItem('refresh_token', this.refreshToken1);
        if (this.idToken !== null || this.accessToken !== null) {
          const decodedIDToken = jwt_decode(this.idToken);
          const decodedACCESSToken = jwt_decode(this.accessToken);
          sessionStorage.setItem('BPG_IDTOKEN', JSON.stringify(decodedIDToken));
          sessionStorage.setItem('BPG_ACCESSTOKEN', JSON.stringify(decodedACCESSToken));
          const BPG_IDTOKEN = sessionStorage.getItem("BPG_IDTOKEN")
          const BPG_ACCESSTOKEN = sessionStorage.getItem("BPG_ACCESSTOKEN")
          const userEmail = JSON.parse(BPG_ACCESSTOKEN)["upn"]
          const userFirstName = JSON.parse(BPG_ACCESSTOKEN)["given_name"]
          const userLastName = JSON.parse(BPG_ACCESSTOKEN)["family_name"]
          const workdayId = JSON.parse(BPG_IDTOKEN)["WorkdayId"]
          sessionStorage.setItem("userEmail", userEmail);
          sessionStorage.setItem("userFirstName", userFirstName);
          sessionStorage.setItem("userLastName", userLastName);
          sessionStorage.setItem("workdayId", workdayId);
          sessionStorage.setItem('loginSuccess', 'true');
          sessionStorage.setItem("firstLogin", 'true');

          if (this.environment1.envName === 'default' || this.environment1.envName === 'local' || this.environment1.envName === 'staging') {
            localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl + '7000');
            localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl + '7001');
            localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl + '7002');
          } else if (this.environment1.envName === 'qa' || this.environment1.envName === 'prod') {
            localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
            localStorage.setItem('eventManagementUrl', this.environment1.eventapiBaseUrl);
            localStorage.setItem('financialManagementUrl', this.environment1.financeapiBaseUrl);
          }
          else {
            localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
            localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl);
            localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl);
          }
          const options = {
            headers: new HttpHeaders({
              'Authorization': sessionStorage.getItem('id_token'),
              'Content-Type': this.contentTypeConstant
            }),
            responseType: 'text' as 'json'
          };
          this.http.get(getXApiKeyUrl, options).subscribe(async (res: any) => {
            const XAapiKey = res;
            sessionStorage.setItem('XAapiKey', XAapiKey);
            this.isTokenReceived.next(true);
 
          })

        }
        

      }

    })
  }



  async refreshToken() {
    let clientId;
    let tokenURL = environment.tokenUrl;
    if (this.environment1.envName === 'default' || this.environment1.envName === 'local' || this.environment1.envName === 'staging') {
      clientId = environmentLocal.clientId
    } else if (this.environment1.envName === 'qa') {
      clientId = environmentQA.clientId
    }
    else if (this.environment1.envName === 'prod') {
      clientId = environmentPROD.clientId
      tokenURL = environmentPROD.tokenUrl
    }
    const data = {
      'grant_type': "refresh_token",
      'client_id': clientId,
      'refresh_token': sessionStorage.getItem('refresh_token')
    };

    const refreshBody = [];
    for (const property in data) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(data[property]);
      refreshBody.push(`${encodedKey}=${encodedValue}`);
    }

    const body = refreshBody.join("&");
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': this.contentTypeConstant,
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': this.contentTypeConstant,
        })
      };
    }


    this.http.post(tokenURL, body, httpOptions).subscribe(async (res: any) => {
      if (res !== null) {
        if (res !== null) {
          this.idToken = res.id_token
          this.accessToken = res.access_token
          this.refreshToken1 = res.refresh_token
          sessionStorage.setItem('id_token', this.idToken)
          sessionStorage.setItem('refresh_token', this.refreshToken1)
        }
      }
    })
  }

  setloggedInHeader() {
    this.setloggedInSubject$.next(true);
  }
 



  /** For service call to get bpg list depending on site(location)
   * @class BpgCommonService
   * @method getBPGsList
   * @param landingData
   * @returns Observable
   */

  getBPGsList(landingData: any): Observable<any> {
    const getBPGListUrl = this.membershipUrl + ConstantValues.membershipApiUrl.sitebpgList;
    return this.http.post(getBPGListUrl, landingData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }
  /** For service call to get bpg list depending on userId
    * @class BpgCommonService
    * @method getMyBPGsList
    * @param myBpgsData
    * @returns Observable
    */

  getMyBPGsList(myBpgsData: any): Observable<any> {
    const getBPGListUrl = this.membershipUrl + ConstantValues.membershipApiUrl.bpgList;
    return this.http.post(getBPGListUrl, myBpgsData, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));
  }
  /** For service call to get site list depending on userId
  * @class BpgCommonService
  * @method getSiteist
  * @param mysiteData
  * @returns Observable
  */

  getMySiteList(mysiteData: any): Observable<any> {
    const getSiteListUrl = this.membershipUrl + ConstantValues.membershipApiUrl.siteList;
    return this.http.post(getSiteListUrl, mysiteData, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));
  }

  /** For service call to get site list depending on userId
  * @class BpgCommonService
  * @method getSiteist
  * @param mysiteData
  * @returns Observable
  */

   getNaacAdminChapters(mysiteData: any): Observable<any> {
    const getNaacAdminChaptersUrl = this.membershipUrl + ConstantValues.membershipApiUrl.getNaacAdminChapters;
    return this.http.post(getNaacAdminChaptersUrl, mysiteData, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));
  }
  /** For service call to get site list of the user
   * @class BpgCommonService
   * @method getSiteList
   * @param myBpgsData
   * @returns Observable
   */
  getSiteList(siteData: any): Observable<any> {
    const getBPGListUrl = this.membershipUrl + ConstantValues.userManagementApiUrl.siteList;
    return this.http.post(getBPGListUrl, siteData, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));
  }

  /** For service call to get site list of the user
   * @class BpgCommonService
   * @method getRegisteredSiteList
   * @param myBpgsData
   * @returns Observable
   */
  getRegisteredSiteList(userId): Observable<any> {
    const getBPGListUrl = this.membershipUrl + this.registerSiteUrl;
    return this.http.get(getBPGListUrl + userId, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));
  }


  /** For service call to get chapter members details depending on siteIds and bpgId
 * @class BpgCommonService
 * @method getChapterEmailList
  * @param myData
 * @returns Observable
 */
  getChapterEmailList(myData: any): Observable<any> {
    const getChapterEmailUrl = this.membershipUrl + ConstantValues.membershipApiUrl.chapterEmailList;
    return this.http.post(getChapterEmailUrl, myData, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }));

  }
  /** For service call to login to bpg application locally
     * @class BpgCommonService
     * @method login
     * @param loginData
     * @returns Observable
     */

  login(loginData: any): Observable<any> {
    const loginUrl = this.commonUrl + ConstantValues.commonApiUrl.login;
    return this.http.post(loginUrl, loginData)
      .pipe(map((data: any) => {
        return data;
      }));

  }

  loginMonitor(loginData: any): Observable<any> {
    const loginUrl = this.commonUrl + ConstantValues.commonApiUrl.loginMonitor;
    return this.http.post(loginUrl, loginData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));
  }

  checkSiteAffected(data:any): Observable<any> {
    const checkSiteAffectedUrl = this.commonUrl + ConstantValues.commonApiUrl.checkSiteAffected;
    return this.http.post(checkSiteAffectedUrl,data, this.tokenizedHeader())  
    .pipe(map((data: any) => {
      return data;
    }));
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getUserRoleDetails
     * @param userData
     * @returns Observable
     */

  getUserRoleDetails(userData: any): Observable<any> {
    const userRoleDetailsUrl = this.commonUrl + ConstantValues.commonApiUrl.userRole;
    return this.http.post(userRoleDetailsUrl, userData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));

  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getChapterDetails
     * @param chapterDetailsData
     * @returns Observable
     */
  getChapterDetails(chapterDetailsData: any): Observable<any> {

    const chapterDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.chapterDetails;
    return this.http.post(chapterDetailsUrl, chapterDetailsData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));

  }

  /** For service call to get chapter folder list
   * @class BpgCommonService
   * @method getChapterFolderDetails
   * @param getChapterFolderDetails
   * @returns Observable
   */
  getChapterFolderDetails(getChapterFolderDetails: any): Observable<any> {

    const chapterDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.chapterFolderDetails;
    return this.http.post(chapterDetailsUrl, getChapterFolderDetails, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));



  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method withdrawMemberShip
     * @param userId
     * @returns Observable
     */
  withdrawMemberShip(userId: any): Observable<any> {
    const withdrawMembershipUrl = this.commonUrl + ConstantValues.userManagementApiUrl.withdrawMembership;
    return this.http.delete(withdrawMembershipUrl + userId, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));
  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getChapterLeadershipDetails
     * @param chapterId
     * @returns Observable
     */
  getChapterLeadershipDetails(chapterId: any): Observable<any> {
    const chapterLeadershipDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.chapterLeadershipDetails;
    return this.http.post(chapterLeadershipDetailsUrl, chapterId, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));

  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getUserSiteDeatils
     * @param siteId
     * @returns Observable
     */
  getUserSiteDeatils(siteId: any): Observable<any> {
    const userSiteDetailsUrl = this.commonUrl + ConstantValues.userManagementApiUrl.userSiteDetails;
    return this.http.post(userSiteDetailsUrl, { "siteId": siteId }, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to get bpg list
     * @class BpgCommonService
     * @method getUserDetails
     * @param userId
     * @returns Observable
     */
  getUserDetails(userId: any): Observable<any> {
    const userDetailUrl = this.commonUrl + ConstantValues.commonApiUrl.userDetails;
    return this.http.post(userDetailUrl, { "userId": userId }, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));

  }

  /** For service call to check for ADAL login
     * @class BpgCommonService
     * @method tokenizedHeader
     * @returns header options
     */
  tokenizedHeader(): any {

    if (localStorage.getItem('logOutFlag') === "true") {
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem("logOutFlag", "true");

    }
    else {
      if (sessionStorage.getItem('id_token') === null) {
        this.userLogin()
      }
      if (sessionStorage.getItem('id_token') !== null) {
        let headers;

        if (sessionStorage.getItem("XAapiKey") !== null && sessionStorage.getItem("XAapiKey") !== undefined) {
           headers = new HttpHeaders({
            Authorization: sessionStorage.getItem("id_token"),
            "X-Api-Key": sessionStorage.getItem("XAapiKey"),
          });
        } else {
           headers = new HttpHeaders({
            Authorization: sessionStorage.getItem("id_token"),
          });
        }
        //}
        return { headers: headers };
      }

    }
  }

  /** For service call to get user data by email id
   * @class BpgCommonService
   * @method userDetailsByEmailId
   * @param emailData
   * @returns Observable
   */

  userDetailsByEmailId(emailData: any): Observable<any> {

    if (this.commonUrl === null) {
      this.commonUrl = localStorage.getItem('userManagementUrl');
    }
    const loginUrl = this.commonUrl + ConstantValues.commonApiUrl.userDetailsByEmailId;

    return this.http.post(loginUrl, emailData, this.tokenizedHeader())
      .pipe(map((data: any) => {

        return data;
      }));
  }

  /** For service call to get AWS Base URL
  * @class BpgCommonService
  * @method getAwsUrl
  * @param awsData
  * @returns Observable
  */

  getAwsUrl(awsData: any): Observable<any> {
    const awsUrl = this.commonUrl + this.getAWSUrl;
    return this.http.post(awsUrl, awsData, this.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      }));
  }

  public logUserAction(data: any): Observable<any> {
    return this.http.post(this.commonUrl + this.logUserActionApi, data, this.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

}
